import React, { useState,useRef } from "react";

import s from "./report-text-field.module.scss";

const ReportTextField = () => {

    return (
        <div className={s.ReportTextField}>
            <div className={s.headerBlock}>

            </div>
            <div className={s.textArea}>
                
            </div>
        </div>
    )
}

export default ReportTextField;